import Select from "react-select";
import normalize from "../utils/NormalizeSelect";

const UserRoleForm = ({
  popup,
  setPopup,
  user,
  setUser,
  processData,
  error,
  setError,
  action,
  roles,
}) => {
  return (
    <div
      className={
        popup === "add" || popup === "edit"
          ? "modal fade show d-block"
          : "modal fade"
      }
      tabIndex={-1}
    >
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {popup === "add" ? "Add New" : "Update"} User
            </h5>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-12 mb-3">
                <div className="fv-row fv-plugins-icon-container fv-plugins-bootstrap5-row-invalid">
                  {/*begin::Input*/}
                  <label className="form-label required">Email</label>
                  <input
                    autoComplete="off"
                    className="form-control"
                    placeholder="Enter Email"
                    value={user?.username ?? ""}
                    onChange={(e) => {
                      processData("text", e, "username");
                    }}
                  />
                  <small className="text-danger mt-2">
                    {error?.username ?? ""}
                  </small>
                  {/*end::Input*/}
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <div className="fv-row fv-plugins-icon-container fv-plugins-bootstrap5-row-invalid">
                  {/*begin::Input*/}
                  <label className="form-label required">Role</label>
                  <Select
                    className="react-select-styled react-select-bordered"
                    classNamePrefix="react-select"
                    options={roles}
                    filterOption={(option, input) => {
                      return normalize(option.label).includes(normalize(input));
                    }}
                    onChange={(e) => {
                      processData("select", e, "roleId");
                    }}
                    value={
                      roles
                        ?.filter((item) => item?.value === user?.roleId)
                        ?.at(0) ?? null
                    }
                    placeholder="Select an option"
                  />
                  <small className="text-danger mt-2">
                    {error?.roleId ?? ""}
                  </small>
                  {/*end::Input*/}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              onClick={() => {
                setUser({});
                setPopup("");
                setError({});
              }}
              type="button"
              className="btn btn-light btn-sm"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={() => action(popup)}
            >
              {popup === "add" ? "Add" : "Update"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserRoleForm;
